import { buildingThresholdsApi } from './buildingsApi';
import { locationApi } from './locationApi';
import { partnerHealthStatusApi } from './partnerHealthStatusApi';
import { thresholdsApi } from './thresholdsApi';
import { virtualDevicesApi, virtualDevicesMutationApi } from './virtualDevicesApi';
import { wellReportApi } from './wellReportApi';

export * from './virtualDevicesApi';
export * from './locationApi';
export * from './buildingsApi';
export * from './thresholdsApi';
export * from './partnerHealthStatusApi';
export * from './wellReportApi';

export const businessApiSlices = [
    buildingThresholdsApi,
    locationApi,
    partnerHealthStatusApi,
    thresholdsApi,
    virtualDevicesApi,
    virtualDevicesMutationApi,
    wellReportApi,
];
